import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { DutyAssignment } from '../../store/models/DutyAssignment';
import { ColDef } from 'ag-grid-community';
import { Button, Colors } from '@blueprintjs/core';
import { MAP } from '@blueprintjs/icons/lib/esm/generated/iconNames';
import { observer } from 'mobx-react';
import moment from 'moment';
import BaseGridXL from '../common/grid/BaseGridXL';
import styled from '@emotion/styled';
import { dateFilterNormal, renderGridDateWithDay } from '../../store/utils';
import { DateInput, IDateFormatProps } from '@blueprintjs/datetime';
import { IconNames } from '@blueprintjs/icons';
import { PharmacyDetails } from '../../store/models/PharmacyDetails';

interface PharmacyDutiesListProps extends WithTranslateProps {
  duties: Array<Instance<typeof DutyAssignment>>;
  pharmacyDetails?: Instance<typeof PharmacyDetails>;
}

interface PharmacyDutiesListState {
  searchDate: Date;
}

const DivLeft = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 5%;
  padding-bottom: 5px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const CenterContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const RowActions = (props: { id: number }) => (
  <CenterContainer>
    {/* <Link to={`${Page.Duties}/${props.id}`}>
      <Button minimal={true} icon={EDIT} />
    </Link> */}
    <Button minimal={true} icon={MAP} />
  </CenterContainer>
);

@observer
class PharmacyDutiesList extends React.Component<PharmacyDutiesListProps, PharmacyDutiesListState> {
  state = {
    searchDate: new Date(),
  } as PharmacyDutiesListState;

  handleDateChange = (date: Date) => {
    this.setState({ searchDate: date });
  };

  columns = [
    {
      headerName: this.props.translate(TLCode.PHARMACY_DUTIES_Date),
      field: 'date',
      width: 100,
      sort: 'asc',
      cellRenderer: renderGridDateWithDay,
      filterParams: {
        textCustomComparator: dateFilterNormal,
      },
    },
    { headerName: this.props.translate(TLCode.PHARMACY_DUTIES_Hour), field: 'dutyType', width: 100 },
    {},
    // {
    //   width: 100,
    //   headerName: '',
    //   sortable: false,
    //   filter: false,
    //   cellRendererFramework: RowActions,
    //   cellRendererParams: (params: ICellRendererParams) => {
    //     return { id: params.data.dutyId };
    //   },
    // },
  ] as ColDef[];

  buildGridData = () => {
    const start = new Date(this.state.searchDate.getFullYear(), 0, 1);
    const end = new Date(this.state.searchDate.getFullYear() + 1, 0, 1);
    return this.props.duties
      .filter((d) => new Date(d.duty!.dutyDate.date) >= start && new Date(d.duty!.dutyDate.date) <= end)
      .map((d) => ({
        id: d.dutyAssignmentId,
        dutyType: this.props.translate(d.duty!.dutyType!.type === 'DAY' ? TLCode.DutyTypeDay : TLCode.DutyTypeNight),
        dutyId: d.duty!.dutyId,
        date: d.duty!.dutyDate.date,
        pharmacyName: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.name : '',
        pharmacyApbNumber: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.apbNumber : '',
        pharmacyAddress: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.address : '',
        pharmacyCity: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.city : '',
        pharmacyZip: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.zipCode : '',
        pharmacyPhoneNumber: d !== undefined && d.pharmacySimple ? d.pharmacySimple!.mobile : '',
      }));
  };

  toggleColor = (color) => {
    if (color == Colors.WHITE) {
      return Colors.LIGHT_GRAY4;
    } else {
      return Colors.WHITE;
    }
  };

  render() {
    let backgroundColor = Colors.WHITE;
    const searchDate = new Date();
    const jsDateFormatter: IDateFormatProps = {
      // note that the native implementation of Date functions differs between browsers
      formatDate: (date) => {
        date.setDate(1);
        date.setMonth(0);
        return date.getFullYear().toString();
      },
      parseDate: (str) => new Date(str),
      placeholder: 'M/D/YYYY',
    };
    const minDate = new Date('01/01/2019');
    const maxDate = new Date('01/01/2029');
    const { pharmacyDetails } = this.props;

    return (
      <>
        {' '}
        <Container>
          <b>
            ({pharmacyDetails!.level})&nbsp;&nbsp;{pharmacyDetails!.apbNumber}&nbsp;-&nbsp;{pharmacyDetails!.name}
            &nbsp;-&nbsp;{pharmacyDetails!.address},&nbsp;
            {pharmacyDetails!.zipCode}&nbsp;
            {pharmacyDetails!.city}
          </b>
          <br />
          <DivLeft>
            <Button
              icon={IconNames.CHEVRON_LEFT}
              small={true}
              style={{ height: '30px', marginRight: '5px' }}
              onClick={() => {
                const date = moment(this.state.searchDate).subtract(1, 'y');
                this.setState({ searchDate: date.toDate() });
                // this.searchDuties({ date: date.format(), notAssigned: false });
              }}
              disabled={this.state.searchDate.getFullYear() === 2019}
            />
            <DateInput
              value={this.state.searchDate}
              {...jsDateFormatter}
              minDate={minDate}
              maxDate={maxDate}
              onChange={this.handleDateChange}
            />
            <Button
              icon={IconNames.CHEVRON_RIGHT}
              small={true}
              style={{ height: '30px', marginLeft: '5px' }}
              onClick={() => {
                const date = moment(this.state.searchDate).add(1, 'y');
                this.setState({ searchDate: date.toDate() });
                // this.searchDuties({ date: date.format(), notAssigned: false });
              }}
              disabled={this.state.searchDate.getFullYear() === maxDate.getFullYear()}
            />
            {/* <p>&nbsp;&nbsp;<b>{this.props.translate(TLCode.PHARMACY_DUTIES_Explanation_1)}</b></p> */}
          </DivLeft>
          <BaseGridXL
            columnDefs={this.columns}
            rowData={this.buildGridData()}
            keyName={'id'}
            // quickFilterText={this.state.searchDate.getFullYear().toString()}
            getRowStyle={(params) => {
              console.log(params);
              // if (params.node.rowIndex == 0) {
              //   return {
              //     'background-color': backgroundColor,
              //   };
              // } else {
              //   const prevDate = params.api.getDisplayedRowAtIndex(params.node.rowIndex - 1).data.date;
              //   const currDate = params.api.getDisplayedRowAtIndex(params.node.rowIndex).data.date;
              //   if (currDate.includes('-01-01T00:00:00')) {
              //     backgroundColor = Colors.VERMILION5
              //   } else if (prevDate != currDate) {
              //     backgroundColor = this.toggleColor(backgroundColor);
              //   }
              //   return {
              //     'background-color': backgroundColor,
              //   };
              // }
              var year = new Date().getFullYear() + 1;
              const currDate = params.api.getDisplayedRowAtIndex(params.node.rowIndex).data.date;
              if (currDate.includes(year + '-01-01T00:00:00')) {
                return {
                  'background-color': Colors.VERMILION5,
                };
              }
              if (params.node.rowIndex == 0) {
                return {
                  'background-color': backgroundColor,
                };
              } else {
                const prevDate = params.api.getDisplayedRowAtIndex(params.node.rowIndex - 1).data.date;
                if (prevDate != currDate) {
                  backgroundColor = this.toggleColor(backgroundColor);
                }
                return {
                  'background-color': backgroundColor,
                };
              }
            }}
          />
        </Container>
      </>
    );
  }
}

export default withTranslate(PharmacyDutiesList);
